import { formatCurrency, formatNumber } from './calculations';

const logoUrl =
  'http://mindtechnology.ai/wp-content/uploads/2025/04/LOGO-100-X-100-MIND-TECHNOLOGY.png';

const escapeHtml = (value) =>
  String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

export const downloadBudgetReport = ({ settings, calculations }) => {
  const rows = calculations.activeItems
    .map(
      (item) => `
        <tr>
          <td>${escapeHtml(item.category)}</td>
          <td>${escapeHtml(item.name)}</td>
          <td>${item.quantity}</td>
          <td>${formatCurrency(item.rate)}</td>
          <td>${formatCurrency(item.quantity * item.rate * calculations.locationMultiplier)}</td>
        </tr>
      `
    )
    .join('');

  const report = `
    <!doctype html>
    <html lang="en">
      <head>
        <meta charset="utf-8">
        <title>${escapeHtml(settings.eventName)} - Budget Report</title>
        <style>
          body { margin: 0; padding: 40px; color: #161637; font: 14px Arial, sans-serif; }
          header { display: flex; align-items: center; justify-content: space-between; border-bottom: 3px solid #8068ff; padding-bottom: 24px; }
          header img { width: 76px; height: 76px; object-fit: contain; }
          h1 { margin: 0 0 8px; color: #080a24; font-size: 28px; }
          h2 { margin-top: 32px; color: #080a24; }
          .meta, .totals { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-top: 24px; }
          .card { padding: 16px; border: 1px solid #dedcf0; border-radius: 10px; background: #f7f7fc; }
          .label { display: block; margin-bottom: 5px; color: #737796; font-size: 11px; text-transform: uppercase; }
          strong { font-size: 18px; }
          table { width: 100%; margin-top: 16px; border-collapse: collapse; }
          th, td { padding: 11px 8px; border-bottom: 1px solid #e4e3f2; text-align: left; }
          th { color: #5f51ce; font-size: 11px; text-transform: uppercase; }
          .right { text-align: right; }
          .note { margin-top: 32px; color: #666985; font-size: 12px; line-height: 1.6; }
        </style>
      </head>
      <body>
        <header>
          <div>
            <h1>${escapeHtml(settings.eventName)}</h1>
            <div>${escapeHtml(settings.city)}, ${escapeHtml(settings.country)} · Conference advertising budget report</div>
          </div>
          <img src="${logoUrl}" alt="Mind Technology">
        </header>

        <div class="meta">
          <div class="card"><span class="label">Estimated total</span><strong>${formatCurrency(calculations.total)}</strong></div>
          <div class="card"><span class="label">Approved budget</span><strong>${formatCurrency(settings.budgetCap)}</strong></div>
          <div class="card"><span class="label">Destination adjustment</span><strong>${settings.locationAdjustment >= 0 ? '+' : ''}${settings.locationAdjustment}%</strong></div>
        </div>

        <h2>Selected advertising inventory</h2>
        <table>
          <thead>
            <tr><th>Category</th><th>Placement</th><th>Quantity</th><th>Unit rate</th><th class="right">Estimated total</th></tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>

        <div class="totals">
          <div class="card"><span class="label">Media subtotal</span><strong>${formatCurrency(calculations.grossSubtotal)}</strong></div>
          <div class="card"><span class="label">Contingency</span><strong>${formatCurrency(calculations.contingency)}</strong></div>
          <div class="card"><span class="label">Tax and fees</span><strong>${formatCurrency(calculations.tax)}</strong></div>
        </div>

        <p class="note">
          Planning estimates only. Validate rates, taxes, venue terms, compliance requirements,
          fair-market-value guidance, and contractual obligations with the medical society and
          selected vendors. Generated by Mind Technology Conference Budget Studio.
        </p>
      </body>
    </html>
  `;

  const blob = new Blob([report], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `${settings.eventName.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}-budget-report.html`;
  anchor.click();
  URL.revokeObjectURL(url);
};